import { Assets, Text, Application, Container, Texture, Sprite } from 'pixi.js';
import { Point } from '../models/point';
import { Store } from '@ngrx/store';
import * as GamesActions from '@app/store/features/games/games.actions';

export class Seat {
    container = new Container();
    private seatSprite: Sprite;

    constructor(
        private readonly _textures: { default: Texture, click: Texture },
        private readonly _data: { tableId: number, seatPosition: number },
        private readonly _position: Point,
        private readonly _store: Store<any>
    ) {
        this.seatSprite = new Sprite(_textures.default);
        this.container.position.set(_position.x, _position.y);
        this.seatSprite.eventMode = 'static'
        this.seatSprite.cursor = 'pointer';

        this.seatSprite.on('pointerdown', () => {
            this.seatSprite.texture = _textures.click;
            this._store.dispatch(GamesActions.takeSeat({ idTable: _data.tableId, seatPosition: _data.seatPosition }))
        });
        this.seatSprite.on('pointerup', () => {
            this.seatSprite.texture = _textures.default;

        });

        this.container.addChild(this.seatSprite);
    }

    hideSeat(): void {
        this.container.visible = false;
    }

    showSeat(): void {
        this.container.visible = true;
    }

    setPosition(position: Point): void {
        this.container.position.set(position.x, position.y);
    }

    destroy(): void {
        // 🔧 FIX: Remove event listeners to prevent memory leaks
        this.seatSprite?.removeAllListeners('pointerdown');
        this.seatSprite?.removeAllListeners('pointerup');
        
        // 🔧 FIX: Explicitly destroy sprite to prevent canvas memory leaks
        if (this.seatSprite) {
            this.seatSprite.destroy({ children: true, texture: false });
            this.seatSprite = null as any;
        }
        
        // Destroy container and children
        this.container?.removeChildren();
        this.container?.destroy({ children: true, texture: false });
        this.container = null as any;
    }

}